<template>
  <div class="empty-data-container ">
      <img src="@/assets/404-no-data-found.jpg" v-if="showImage"/>
      <h2 v-if="error!=1">{{$t('sorry')}}</h2>
      <p v-if="error!=1">{{msg}}</p>
      <h2 v-else>{{msg}}</h2>
  </div>
</template>

<script>
export default {
  name: "EmptyData",
  computed: {
    msg() {
      if(this.error == 1)
        return this.$t('no_data_found')
      else  if(this.error == 2)
        return this.$t('something_went_wrong')
      else 
        return this.error
    }
  },
  props: {
    error:{
      default: () => 2
    }, 
    showImage: {
      default: () => false
    }
  }
}
</script>

<style scoped>
.empty-data-container {
  position: absolute;
  top: 3px;
  left: 0;
  z-index: 3;
  height: 96%;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 20px;
  /* background-color: white; */
}

.empty-data-container img {
  width: 50%;
}

@media screen and (max-width: 600px) {
  .empty-data-container img {
    width: 100%;
  }
}

</style>